const CouponCodeStyles = {
    baseStyle: {
        accordionButton: {
            fontFamily: 'inter',
            color: 'black.100',
            justifyContent: 'space-between',
            variant: 'link',
            fontSize: '14px',
            padding: '10px 15px',
            background: 'white',
            fontWeight: 400,
            fontStyle: 'Regular',
            lineHeight: '22px',
            letterSpacing: '0.07px',
            _hover: {
                backgroundColor: 'none',
                textDecoration: 'none'
            }
        },
        birthdayConflictMessage: {
            color: 'red.950',
            fontSize: '16px',
            fontWeight: 300,
            fontFamily: 'inter',
            marginTop: '14px'
        },
        promoAppliedIcon: {
            color: 'black.100',
            boxSize: '24px',
            marginTop: '4px'
        },
        accordionPanel: {
            '& .chakra-form-control': {
                '& > .chakra-form__label': {
                    pointerEvents: 'none',
                    fontWeight: 400
                }
            },
            '& .chakra-input__group': {
                alignItems: 'center',
                '& > input[type="text"]': {
                    padding: '16px 15px 6px',
                    fontWeight: 500
                },
                '& > button[type="submit"]': {
                    color: 'black.100',
                    border: 'none',
                    backgroundColor: 'transparent',
                    textDecoration: 'underline',
                    fontSize: '16px',
                    fontWeight: 300
                }
            }
        }
    }
}

export default CouponCodeStyles
